const GetEmployee = (thiss) => {
  let uri;
  if (thiss.currentUser.PositionID == 16) {
    uri = `/api/Employees/GetByCompany?companyID=${thiss.currentCompany}`;
  } else
    uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?employeeid=${thiss.currentUser.EmployeeId}`;
  // uri = `/api/Employees/GetEmployeeByCriteriaSupervisor?DepartmentID=${thiss.deparmentId}&DirectionID=${thiss.currentUser.DireccionID}&employeeid=${thiss.currentUser.EmployeeId}`;
  thiss.$http
    .get(uri)
    .then((resp) => {
      if (thiss.currentUser.PositionID == 16) {
        resp.data.forEach((element) => {
          thiss.employeesList.push({
            key: element.EmployeeID ? element.EmployeeID : element.Id,
            label: element.FullName ? element.FullName : element.Name
          });
        });
      } else {
        resp.data.user.forEach((element) => {
          thiss.employeesList.push({
            key: element.EmployeeID ? element.EmployeeID : element.Id,
            label: element.FullName ? element.FullName : element.Name
          });
        });

        resp.data.okEmployee.forEach((element) => {
          thiss.employeesList.push({
            key: element.EmployeeID ? element.EmployeeID : element.Id,
            label: element.FullName ? element.FullName : element.Name
          });
        });
      }

      if (thiss.currentUser.EmployeeId != 37) {
        resp.data.user.forEach((element) => {
          thiss.employeesByDirection.push({
            EmployeeID: element.EmployeeID ? element.EmployeeID : element.Id,
            Name: element.FullName ? element.FullName : element.Name
          });
        });

        resp.data.okEmployee.forEach((element) => {
          thiss.employeesByDirection.push({
            EmployeeID: element.EmployeeID ? element.EmployeeID : element.Id,
            Name: element.FullName ? element.FullName : element.Name
          });
        });
      }
      thiss.Setlightbox();
      thiss.confirmRoles();
    })
    .catch((err) => {
      if (err.message.includes("404")) {
        const h = thiss.$createElement;
        thiss.$message({
          type: "info",
          //message: "Cliente no encontrado, consultelo en otra empresa"
          message: h("p", null, [
            h("span", null, "Empleado no "),
            h("i", { style: "color: teal" }, "encontrado")
          ])
        });
      } else {
        thiss.$alert(err.message, err.name, {
          type: "error"
        });
      }
    });
};
export default GetEmployee;
